import { zeroAddress } from "viem"

export const nativeCurrencyAddress = zeroAddress
